/**
 * PostHog service registry — allows each entry point to register its own
 * PostHog service (BO or FO) so shared code like errorHandler.ts does not
 * need static imports of both, which would pull both into every bundle.
 */
let instance = null;
export function setPostHogService(service) {
    instance = service;
}
export function getPostHogService() {
    return instance;
}
